import { Link } from 'react-router-dom';

import {
  DataTable,
  Paginator,
  SkeletonLoader,
  FilterBar,
  PageActions,
  ExportButton,
  naBody,
} from 'components';

import { locales, routes, ROWS_PER_PAGE_OPTIONS } from 'constants/index';

import columns from './columns';
import { ListThreeUiProps } from './ListThree.types';
import InsuredEmployeesChart from './components/InsuredEmployeesChart';

function DetailedInfoBodyTemplate(row: any) {
  return (
    <Link
      className="az-tickets-table__link"
      to={`${routes.listThree.index}/${row['employee_staff_id']}`}
    >
      Read more
    </Link>
  );
}

function HistoryTicketsBodyTemplate(row: any) {
  return (
    <Link
      className="az-tickets-table__link"
      to={`${routes.logs.index}?list=2&employeeId=${row['employee_staff_id']}`}
    >
      Read more
    </Link>
  );
}

export default function ListThree({
  isLoading,
  isExporting,
  totalRecords,
  options,
  filter,
  data,
  handlers,
}: ListThreeUiProps) {
  return (
    <>
      <PageActions>
        <ExportButton
          onClick={handlers.handleDownload}
          loading={isExporting}
          disabled={isExporting || !data.list?.length}
          label={locales.general.exportFullTable}
        />
      </PageActions>

      <div className="mb-4">
        <InsuredEmployeesChart />
      </div>

      <FilterBar
        loading={isLoading}
        onReset={handlers.handleClearAllFilters}
        search={{
          inputs: [
            {
              name: 'azadeaId',
              placeholder: locales.general.azadeaID,
              value: filter.azadeaId || '',
              fieldWidth: 12,
            },
            {
              name: 'personId',
              placeholder: locales.general.personID,
              value: filter.personId || '',
              fieldWidth: 12,
            },
          ],
          onChange: handlers.handleSearchChange,
          onSubmit: handlers.handleSubmitSearch,
          width: 4,
        }}
        filters={[
          {
            kind: 'dropdown',
            name: 'country',
            label: 'Country',
            placeholder: locales.general.filterByCountry,
            fieldWidth: 18,
            value: filter.country || '',
            options: options.countries,
            onChange: handlers.handleCountryChange,
            width: 3,
          },
        ]}
      />

      {isLoading ? (
        <SkeletonLoader height={200} />
      ) : (
        <DataTable
          sortMode="multiple"
          totalRecords={totalRecords}
          columns={columns.map((column) => {
            if (column.field === 'detailedInfo') {
              return {
                ...column,
                body: DetailedInfoBodyTemplate,
              };
            }

            if (column.field === 'historyTickets') {
              return {
                ...column,
                body: HistoryTicketsBodyTemplate,
              };
            }

            return {
              ...column,
              body: naBody(column.field),
            };
          })}
          value={data.list}
        />
      )}

      {data.list?.length > 0 &&
        (isLoading ? (
          <SkeletonLoader height="3rem" width="40rem" />
        ) : (
          <Paginator
            first={filter.first}
            rows={filter.rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
            onPageChange={handlers.handlePageChange}
          />
        ))}
    </>
  );
}
